export const REQUEST_STATUS = {
  APPROVED: {
    id: '019a837e-5b7d-7875-b8da-e55866b26f69',
    name: 'Aprovado',
    color: 'text-[var(--brand-green)]',
    student: {
      name: 'Aprovado',
      color: 'text-[var(--brand-green)]'
    }
  },
  DISAPPROVE: {
    id: '019a837e-7d8b-75f4-965e-7fa3455d59b5',
    name: 'Reprovado',
    color: 'text-[var(--brand-red)]',
    student: {
      name: 'Reprovado',
      color: 'text-[var(--brand-red)]'
    }
  },
  AUTOMATIC_DISAPPROVE: {
    id: '019a837e-d61d-7c6c-96c1-31ba58f2e3dc',
    name: 'Reprovado',
    color: 'text-[var(--brand-red)]',
    student: {
      name: 'Reprovado',
      color: 'text-[var(--brand-red)]'
    }
  },
  UNDER_REVIEW: {
    id: '019a8379-21a5-79a7-ba6d-50de3cb9c486',
    name: 'Em Análise',
    color: 'text-[var(--brand-orange)]',
    student: {
      name: 'Em Análise',
      color: 'text-[var(--brand-orange)]'
    }
  },
  NOT_STARTED: {
    id: '019a8379-4829-7921-8b35-52b6e07ce5c1',
    name: 'Não Iniciado',
    color: 'text-black',
    student: {
      name: 'Em Análise',
      color: 'text-[var(--brand-orange)]'
    }
  },
  GRANT: {
    id: '019a8379-6f0e-7d75-a665-e9db2059ae27',
    name: 'Deferido',
    color: 'text-[var(--brand-green)]',
    student: {
      name: 'Aguardando Aprovação do Aluno',
      color: 'text-[var(--brand-blue-1)]'
    }
  },
  DENY: {
    id: '019a8379-9899-7b81-a26f-6951f06c6a1e',
    name: 'Indeferido',
    color: 'text-[var(--brand-red)]',
    student: {
      name: 'Indeferido',
      color: 'text-[var(--brand-red)]'
    }
  }
}
